import axios from "axios";
import { toast } from "react-toastify";
const baseUrl = process.env.REACT_APP_API_PATH;

export const GetAllNotification = async (data) => {
    try {
        const response = await axios.get(`${baseUrl}/notification/get_latest_notification_by_receiverId?receiverId=${data.id}&receiverRole=${data.role}`);
        return response;
    } catch (error) {
        toast.error(error?.response?.data?.status?.message);
        throw error;
    }
};

export const GetUnreadNotificationCount = async (data) => {
    try {
        const response = await axios.get(`${baseUrl}/notification/unread-count?receiverId=${data.id}&receiverRole=${data.role}`);
        return response;
    } catch (error) {
        toast.error(error?.response?.data?.status?.message);
        throw error;
    }
};

export const ViewNotification = async (data) => {
    try {
        const response = await axios.patch(`${baseUrl}/notification/update_notification_status?receiverId=${data.id}&receiverRole=${data.role}`);
        return response;
    } catch (error) {
        toast.error(error?.response?.data?.status?.message);
        throw error;
    }
};